/* REACT HOT LOADER */ if (module.hot) { (function () { var ReactHotAPI = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-api/modules/index.js"), RootInstanceProvider = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/RootInstanceProvider.js"), ReactMount = require("react-dom/lib/ReactMount"), React = require("react"); module.makeHot = module.hot.data ? module.hot.data.makeHot : ReactHotAPI(function () { return RootInstanceProvider.getRootInstances(ReactMount); }, React); })(); } try { (function () {

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _style6 = require('antd/lib/button/style');

var _button = require('antd/lib/button');

var _button2 = _interopRequireDefault(_button);

var _style7 = require('antd/lib/select/style');

var _select = require('antd/lib/select');

var _select2 = _interopRequireDefault(_select);

var _style8 = require('antd/lib/icon/style');

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _style9 = require('antd/lib/input/style');

var _input = require('antd/lib/input');

var _input2 = _interopRequireDefault(_input);

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _style10 = require('antd/lib/form/style');

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var FormItem = _form2.default.Item;

var Search = function (_Component) {
  (0, _inherits3.default)(Search, _Component);

  function Search(props, context) {
    (0, _classCallCheck3.default)(this, Search);

    var _this = (0, _possibleConstructorReturn3.default)(this, (Search.__proto__ || (0, _getPrototypeOf2.default)(Search)).call(this, props, context));

    _this.search = function (e) {
      e.preventDefault();
      var _this$props = _this.props,
          form = _this$props.form,
          search = _this$props.search;

      _this.props.form.validateFields(function (err, values) {
        console.log(values);
        if (!err) {
          search(values);
        }
      });
    };

    _this.increate = function (e) {
      e.preventDefault();
      var _this$props2 = _this.props,
          form = _this$props2.form,
          increate = _this$props2.increate,
          uid = _this$props2.uid;
      //console.log(this.props)

      increate(uid);
    };

    _this.state = {
      status: null,
      versionList: [{ key: '1', value: '研发版本' }, { key: '2', value: '测试版本' }, { key: '3', value: '发布版本' }]
    };
    return _this;
  }

  (0, _createClass3.default)(Search, [{
    key: 'handleStatusChange',
    value: function handleStatusChange(value) {
      console.log(value);
      this.setState({
        status: value
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          form = _props.form,
          onSubmit = _props.onSubmit;
      var getFieldDecorator = form.getFieldDecorator;
      var versionList = this.state.versionList;

      return (0, _jsx3.default)(_form2.default, {
        layout: 'inline',
        onSubmit: this.search
      }, void 0, (0, _jsx3.default)(FormItem, {}, void 0, getFieldDecorator('keyWord', {
        validateTrigger: ['onChange', 'onBlur'],
        rules: [{ required: false, message: '输入文件名、版本号搜索' }]
      })((0, _jsx3.default)(_input2.default, {
        prefix: (0, _jsx3.default)(_icon2.default, {
          type: 'search',
          style: { fontSize: 13 }
        }),
        placeholder: '\u8F93\u5165\u6587\u4EF6\u540D\u3001\u7248\u672C\u53F7\u641C\u7D22'
      }))), (0, _jsx3.default)(FormItem, {}, void 0, getFieldDecorator("status", {
        // initialValue: onlineStatus
      })((0, _jsx3.default)(_select2.default, {
        showSearch: true,
        size: 'large',
        allowClear: true,
        placeholder: '\u7248\u672C\u72B6\u6001',
        style: { width: 100, marginRight: 20 },
        onChange: this.handleStatusChange.bind(this)
      }, void 0, versionList.map(function (item, index) {
        return (0, _jsx3.default)(Option, {
          value: item.key
        }, index, item.value);
      })))), (0, _jsx3.default)(FormItem, {}, void 0, (0, _jsx3.default)(_button2.default, {
        onClick: this.search,
        className: 'search-btn'
      }, void 0, '\u641C\u7D22')), (0, _jsx3.default)(FormItem, {}, void 0, (0, _jsx3.default)(_button2.default, {
        onClick: this.increate,
        className: 'search-btn',
        type: 'primary'
      }, void 0, '+\u65B0\u589E\u5347\u7EA7\u5305')));
    }
  }]);
  return Search;
}(_react.Component);

var SearchForm = _form2.default.create()(Search);

exports.default = SearchForm;

/* REACT HOT LOADER */ }).call(this); } finally { if (module.hot) { (function () { var foundReactClasses = module.hot.data && module.hot.data.foundReactClasses || false; if (module.exports && module.makeHot) { var makeExportsHot = require("/mnt/xvdb/jenkins/workspace/ProFrontend-Mamobility-Device/node_modules/react-hot-loader/makeExportsHot.js"); if (makeExportsHot(module, require("react"))) { foundReactClasses = true; } var shouldAcceptModule = true && foundReactClasses; if (shouldAcceptModule) { module.hot.accept(function (err) { if (err) { console.error("Cannot apply hot update to " + "search.jsx" + ": " + err.message); } }); } } module.hot.dispose(function (data) { data.makeHot = module.makeHot; data.foundReactClasses = foundReactClasses; }); })(); } }


//////////////////
// WEBPACK FOOTER
// ./src/containers/version/table/search.jsx
// module id = 1525
// module chunks = 0